import { useTranslation } from 'react-i18next'
import { useCurrentWorkspaceDetailQuery, useCurrentWorkspacePaymentFailedInfo } from '../../../hooks/queries'
import PlanLink from './PlanLink'
import { SubscriptionInterval } from '../../../services/payments/annual'

type Props = {
  isCurrent: boolean
  planId: number
  price: number
  interval: SubscriptionInterval
}

export default function CheckoutLink({ isCurrent, planId, price, interval }: Props) {
  const { t } = useTranslation('plan-info-modal')
  const { data: currentWorkspace } = useCurrentWorkspaceDetailQuery()
  const { paymentFailed } = useCurrentWorkspacePaymentFailedInfo()

  // 결제 실패 유예 중에는 체크아웃으로 넘기지 않는다 (정책 9.2). 완전 실패면 PAUSE 라 유예가 아니다.
  // 카드를 바꿔도 재시도가 성공하기 전까지는 유예다 — paymentMethodChanged 로 풀지 않는다.
  const inGrace = currentWorkspace?.subscription?.status !== 'PAUSE' && paymentFailed

  // 주기는 1·12 를 항상 싣는다. 월간일 때 빼면 BE 가 "현재 주기 유지"로 읽어
  // 연간 구독자의 연 → 월 전환이 아예 전달되지 않는다 (BE aivatar #357 T-D2).
  const href = `/workspace/${currentWorkspace?.id}/subscription/checkout?plan=${planId}&interval=${interval}`

  // 현재플랜이다 ? 무조건 현재플랜 이라는 표시 보여주기
  if (isCurrent) {
    return <PlanLink disabled>{t('현재 플랜')}</PlanLink>
  }

  if (price === 0) return null
  // PlanLink 의 disabled 는 색만 바꾼다 — href 를 넘기지 않아야 실제로 막힌다
  if (inGrace) return <PlanLink disabled>{t('플랜 변경')}</PlanLink>
  return <PlanLink href={href}>{t('플랜 변경')}</PlanLink>
}
